var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 332.21,
    height: 128.22,
    viewBox: "0 0 332.21 128.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2069",
    "data-name": "Rectangle 2069",
    width: 332.21,
    height: 128.22,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2343",
    "data-name": "Groupe 2343",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2886",
    "data-name": "Trac\\xE9 2886",
    d: "M426.316,275.217c-.014.629,0,1.257,0,1.886A57.61,57.61,0,0,1,420.9,299.4c-.239.5-.474.839-1.131.79-.562-.042-.658-.174-.521-.716a53.527,53.527,0,0,0,1.355-6.7,13.118,13.118,0,0,0-.047-3.753,4.236,4.236,0,0,0-4.457-3.871,10.1,10.1,0,1,1,10.221-9.926",
    transform: "translate(-334.794 -218.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2887",
    "data-name": "Trac\\xE9 2887",
    d: "M159.1,115.18a43.886,43.886,0,1,0,43.887,43.885A43.885,43.885,0,0,0,159.1,115.18m-2.4,43.53a60.653,60.653,0,0,1-5.409,19.224,30.55,30.55,0,0,1-1.9,3.444c-.156.241-.279.467-.641.467-3.594-.011-7.189-.007-10.871-.007.5-1.824,1-3.573,1.464-5.328a66.725,66.725,0,0,0,1.694-7.769c.016-.112.04-.225.051-.337.163-1.484.156-1.491-1.282-1.67a15.256,15.256,0,0,1-13.255-14.273,15.275,15.275,0,0,1,30.358-3.141,34.836,34.836,0,0,1-.211,9.389m29.192,19.224a30.567,30.567,0,0,1-1.9,3.444c-.155.241-.277.467-.639.467-3.6-.011-7.191-.007-10.871-.007.5-1.824,1-3.573,1.462-5.328a66.731,66.731,0,0,0,1.7-7.769c.014-.112.039-.225.051-.337.162-1.484.156-1.491-1.283-1.67a15.256,15.256,0,0,1-13.255-14.273,15.275,15.275,0,0,1,30.358-3.141,34.764,34.764,0,0,1-.209,9.389,60.7,60.7,0,0,1-5.409,19.224m-45.93-36.32a10.1,10.1,0,0,0,1.728,20.033,4.233,4.233,0,0,1,4.457,3.871,13.18,13.18,0,0,1,.049,3.753,53.509,53.509,0,0,1-1.357,6.7c-.135.542-.039.674.521.716.658.049.892-.288,1.131-.79a57.643,57.643,0,0,0,5.418-22.294c0-.629-.012-1.257,0-1.886a10.067,10.067,0,0,0-11.949-10.107",
    transform: "translate(-94.99 -94.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2888",
    "data-name": "Trac\\xE9 2888",
    d: "M229.231,277.1a57.643,57.643,0,0,1-5.418,22.294c-.239.5-.472.839-1.131.79-.56-.042-.657-.174-.521-.716a53.511,53.511,0,0,0,1.357-6.7,13.179,13.179,0,0,0-.049-3.753,4.233,4.233,0,0,0-4.457-3.871,10.1,10.1,0,1,1,10.221-9.926c-.014.629,0,1.257,0,1.886",
    transform: "translate(-172.311 -218.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2889",
    "data-name": "Trac\\xE9 2889",
    d: "M426.313,277.1A57.61,57.61,0,0,1,420.9,299.4c-.239.5-.474.839-1.131.79-.562-.042-.658-.174-.521-.716a53.527,53.527,0,0,0,1.355-6.7,13.118,13.118,0,0,0-.047-3.753,4.236,4.236,0,0,0-4.457-3.871,10.1,10.1,0,1,1,10.221-9.926c-.014.629,0,1.257,0,1.886",
    transform: "translate(-334.794 -218.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2890",
    "data-name": "Trac\\xE9 2890",
    d: "M730.87,306.72a6.369,6.369,0,0,0-2.791-2.516,10.152,10.152,0,0,0-4.508-.915h-8.394v22.8h4.572v-8.753h3.822a9.861,9.861,0,0,0,4.654-.98,6.344,6.344,0,0,0,2.711-2.581,7.364,7.364,0,0,0-.065-7.054m-4.686,6.059a3.963,3.963,0,0,1-2.809.866h-3.627v-6.631h3.627q3.721,0,3.722,3.332a3.189,3.189,0,0,1-.913,2.433",
    transform: "translate(-589.62 -250.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2891",
    "data-name": "Trac\\xE9 2891",
    d: "M842.047,330.09v9.961a4.693,4.693,0,0,1-1.078,3.315,3.857,3.857,0,0,1-2.972,1.16,3.818,3.818,0,0,1-2.941-1.16,4.693,4.693,0,0,1-1.078-3.315V330.09h-4.572V340.7a8.729,8.729,0,0,0,.93,4.164,6.322,6.322,0,0,0,2.563,2.646,7.668,7.668,0,0,0,3.757.9,7.162,7.162,0,0,0,3.086-.671,6.024,6.024,0,0,0,2.3-1.845v2.286h4.6V330.09Z",
    transform: "translate(-683.796 -272.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2892",
    "data-name": "Trac\\xE9 2892",
    d: "M970.61,330.64a6.974,6.974,0,0,0-5.226-2.04,7.223,7.223,0,0,0-3.118.669,6.308,6.308,0,0,0-2.335,1.845v-2.252h-4.573v18.093h4.573V336.96a4.643,4.643,0,0,1,1.094-3.315,3.912,3.912,0,0,1,2.988-1.159,3.817,3.817,0,0,1,2.939,1.159,4.686,4.686,0,0,1,1.078,3.315v9.995H972.6V336.34a7.817,7.817,0,0,0-1.993-5.7",
    transform: "translate(-787.635 -270.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2893",
    "data-name": "Trac\\xE9 2893",
    d: "M1082.594,343.173a3.767,3.767,0,0,1-3.1-1.42,7.634,7.634,0,0,1,0-8.035,3.772,3.772,0,0,1,3.1-1.42,3.847,3.847,0,0,1,2.3.669,3.609,3.609,0,0,1,1.322,1.847h4.933a8.192,8.192,0,0,0-2.956-4.721,8.927,8.927,0,0,0-5.569-1.682,9.153,9.153,0,0,0-4.638,1.16,8.166,8.166,0,0,0-3.169,3.266,11.141,11.141,0,0,0,0,9.831,8.165,8.165,0,0,0,3.169,3.265,9.153,9.153,0,0,0,4.638,1.16,8.765,8.765,0,0,0,5.553-1.731,8.352,8.352,0,0,0,2.972-4.672h-4.933a3.468,3.468,0,0,1-3.625,2.482",
    transform: "translate(-885.182 -270.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2894",
    "data-name": "Trac\\xE9 2894",
    d: "M1210.765,304.837a6.21,6.21,0,0,0-2.5-2.646,7.353,7.353,0,0,0-3.659-.9,7.791,7.791,0,0,0-3.265.669,5.958,5.958,0,0,0-2.353,1.845V295.48h-4.573v24.169h4.573v-9.995a4.651,4.651,0,0,1,1.094-3.315,3.915,3.915,0,0,1,2.99-1.159,3.816,3.816,0,0,1,2.939,1.159,4.694,4.694,0,0,1,1.078,3.315v9.995h4.573V309.035a9.089,9.089,0,0,0-.9-4.2",
    transform: "translate(-984.725 -243.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2895",
    "data-name": "Trac\\xE9 2895",
    d: "M1330.64,330.09l-3.2,13.75-3.4-13.75h-4.835l-3.462,13.783-3.2-13.783h-4.638l5.325,18.093h4.963l3.3-12.64,3.3,12.64h4.933l5.291-18.093Z",
    transform: "translate(-1078.291 -272.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2896",
    "data-name": "Trac\\xE9 2896",
    d: "M1489.39,332.852a8.506,8.506,0,0,0-3.348-3.281,10.244,10.244,0,0,0-9.471,0,8.5,8.5,0,0,0-3.348,3.281,9.636,9.636,0,0,0-1.225,4.9,9.834,9.834,0,0,0,1.192,4.9,8.347,8.347,0,0,0,3.283,3.281,9.52,9.52,0,0,0,4.7,1.16,9.868,9.868,0,0,0,4.786-1.16,8.7,8.7,0,0,0,3.4-3.281,9.426,9.426,0,0,0,1.259-4.9,9.636,9.636,0,0,0-1.225-4.9m-4.131,7.839a4.393,4.393,0,0,1-1.749,1.814,4.744,4.744,0,0,1-2.335.6,4.243,4.243,0,0,1-3.25-1.389,5.613,5.613,0,0,1-1.291-3.968,5.527,5.527,0,0,1,1.322-3.968,4.348,4.348,0,0,1,3.283-1.389,4.455,4.455,0,0,1,3.316,1.389,5.45,5.45,0,0,1,1.355,3.968,6.1,6.1,0,0,1-.653,2.939",
    transform: "translate(-1213.573 -270.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2897",
    "data-name": "Trac\\xE9 2897",
    d: "M1606.124,329.416a6.423,6.423,0,0,0-2.3,2.254v-2.809h-4.573v18.093h4.573v-9.013a3.812,3.812,0,0,1,4.344-4.54h1.209v-4.8a6.4,6.4,0,0,0-3.25.816",
    transform: "translate(-1318.483 -270.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2898",
    "data-name": "Trac\\xE9 2898",
    d: "M1683.965,295.48v8.59a6.731,6.731,0,0,0-2.547-2.042,7.694,7.694,0,0,0-3.364-.767,7.885,7.885,0,0,0-7.2,4.41,10.458,10.458,0,0,0-1.1,4.867,10.633,10.633,0,0,0,1.1,4.916,8.167,8.167,0,0,0,2.988,3.315,7.761,7.761,0,0,0,4.18,1.176,7.473,7.473,0,0,0,3.561-.816,6.185,6.185,0,0,0,2.384-2.156v2.677h4.638V295.48Zm-.62,17.981a4.605,4.605,0,0,1-1.764,1.829,4.713,4.713,0,0,1-2.385.637,4.46,4.46,0,0,1-2.335-.655,4.812,4.812,0,0,1-1.764-1.877,5.867,5.867,0,0,1-.669-2.858,5.686,5.686,0,0,1,.669-2.827,4.675,4.675,0,0,1,1.749-1.812,4.62,4.62,0,0,1,2.351-.621,4.713,4.713,0,0,1,2.385.637,4.6,4.6,0,0,1,1.764,1.829,6.583,6.583,0,0,1,0,5.716",
    transform: "translate(-1376.614 -243.606)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.4b4e2b0a079fda9a592285661257c4b4.svg";
export { ForwardRef as ReactComponent };